module.exports = __webpack_public_path__ + "static/media/cordova.3c35a76a.png";